import { ChangeDetectorRef, Component, HostListener } from '@angular/core';

@Component({
  selector: 'c-scroll-progress',
  templateUrl: './scroll-progress.component.html',
  styleUrl: './scroll-progress.component.css',
  standalone: false,
})
export class ScrollProgressComponent {
  scrollProgress = 0;

  constructor(private cdr: ChangeDetectorRef) {}

  @HostListener('window:scroll')
  onWindowScroll() {
    const scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;
    const scrollHeight =
      document.documentElement.scrollHeight -
      document.documentElement.clientHeight;
    this.scrollProgress = (scrollTop / scrollHeight) * 100;
    this.cdr.detectChanges();
  }
}
